// extracted by mini-css-extract-plugin
export default {"inlineIcon":"BasicEditorTutorial_inlineIcon__9ZAzZ","inputKey":"BasicEditorTutorial_inputKey__qn1EL"};